import { render, staticRenderFns } from "./rewards.vue?vue&type=template&id=60f954bd&scoped=true&"
import script from "./rewards.vue?vue&type=script&lang=js&"
export * from "./rewards.vue?vue&type=script&lang=js&"
import style0 from "./rewards.vue?vue&type=style&index=0&id=60f954bd&lang=scss&scoped=true&"
import style1 from "./rewards.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f954bd",
  null
  
)

export default component.exports